import { Languages, Types } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';
import { StatusValue } from './admin-knowledge-base.type';

export const statusColorsMap: Record<StatusValue, string> = {
    deleted: 'coral',
    draft: 'orange',
    planned: 'royalblue',
    published: 'darkgreen',
    to_delete: 'brown',
};

export const displayedStatusMap: Record<StatusValue, string> = {
    deleted: 'Удалена',
    draft: 'Черновик',
    planned: 'Запланирована',
    published: 'Опубликована',
    to_delete: 'На удаление',
};

export const languages = [Languages.RU, Languages.KK, Languages.EN];

export const langLabels: Record<Languages, string> = {
    ru: 'Русский',
    kk: 'Қазақша',
    en: 'English',
    qq: 'Qazaqsha',
};

export const ruLangLabels: Record<Languages, string> = {
    ru: 'русский',
    kk: 'казахский',
    en: 'английский',
    qq: 'казахский (латиница)',
};

export const types: Record<Types, string> = {
    [Types.ARTICLE]: 'Статья',
    [Types.CATEGORY]: 'Категория',
    [Types.TAG]: 'Рубрика',
    [Types.SECTION]: 'Раздел',
};

export const formLabels: Record<Types, string> = {
    [Types.ARTICLE]: 'статью',
    [Types.CATEGORY]: 'категорию',
    [Types.TAG]: 'рубрику',
    [Types.SECTION]: 'раздел',
};

export const DEFAULT_ACTIONS_LABEL = 'Действия';

export const ANIMATION_DURATION = 1000;
